module.exports = __webpack_public_path__ + "static/media/to-stack.32b59992.svg";